<template>
  <fvSelect class="form-control select text-right fv-size-md" v-model="valData" :options="options"
    :placeholder="placeholder" text-key="name" value-key="id" :search="true">
    <template slot="value" slot-scope="scope">
      {{ findValueObject(scope.value).value }}
    </template>
    <template slot="option" slot-scope="scope">
      <div dir="ltr" class="text-left">
        <b>{{ scope.option.value }}</b>
      </div>
    </template>
  </fvSelect>
</template>

<script>

export default {
  props: {
    placeholder: {
      type: String
    },
    id: {
      type: String
    },
    value: {
      type: String,
      default: undefined
    },
    required: [Boolean, Function],
  },
  data() {
    return {
      options: [
        {
          id: 'ریال',
          value: 'ریال',
          default: true
        },
        {
          id: 'یورو',
          value: 'یورو'
        }
      ]
    }
  },
  created() {
  },
  computed: {
    valData: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    findValueObject(value) {
      return this.options.find((option) => option.value === value) || false;
    }
  }
}
</script>

<style lang="scss"></style>
